import { render, staticRenderFns } from "./DeputyUser.vue?vue&type=template&id=79ec562d&"
import script from "./DeputyUser.vue?vue&type=script&lang=js&"
export * from "./DeputyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports